import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import logo from "../../airlyze_logo.png";
import { showSidebar } from "../../redux/actions/sidebarActions";
import { getUser, removeUserSession } from "../../Utils/Common";
import { useStyles } from "../../Utils/Styles";
import AlertMenu from "./AlertMenu";

export default function Topbar() {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { sidebarOpen } = useSelector((state) => state.sideBar);

  const handleLogout = () => {
    removeUserSession();
    history.push("/dashboard");
  };

  return (
    <AppBar
      position="absolute"
      className={clsx(classes.appBar, sidebarOpen && classes.appBarShift)}
    >
      <Toolbar className={classes.toolbar}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={() => {
            dispatch(showSidebar(!sidebarOpen));
          }}
          className={clsx(
            classes.menuButton,
            sidebarOpen && classes.menuButtonHidden
          )}
        >
          <MenuIcon />
        </IconButton>
        <div
          style={{
            width: 38,
            height: 30,
            marginLeft: -25,
            marginRight: 10,
            filter: "brightness(10)",
            backgroundSize: "cover",
            backgroundImage: `url(${logo})`,
          }}
        ></div>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          className={classes.title}
        >
          {""}
        </Typography>
        {getUser().permissionlevel === 1 ? (
          <Button
            className={classes.topBarButton}
            style={{ marginRight: 10 }}
            onClick={() => {
              history.push(
                window.location.href.includes("/cpanel")
                  ? "/dashboard"
                  : "/cpanel"
              );
            }}
          >
            <Typography style={{ color: "white" }}>
              {window.location.href.includes("/cpanel")
                ? t("topbar.linkToDashboard")
                : t("topbar.linkToCpanel")}
            </Typography>
          </Button>
        ) : undefined}
        <Typography
          className={classes.topBarButton}
          style={{ marginRight: 10 }}
        >
          {t("topbar.welcome") + " " + getUser().username}
        </Typography>
        <AlertMenu />
        <Button className={classes.topBarButton} onClick={handleLogout}>
          <Typography style={{ color: "white" }}>
            {t("topbar.logout")}
          </Typography>
        </Button>
      </Toolbar>
    </AppBar>
  );
}
